import { OutlineButton } from "components/button";
import { useModalContext } from "components/modal";
import Spinner from "components/spinner";
import { useAppointmentChecklists } from "features/requests/hooks/useAppointmentChecklists";
import { IChecklistWithResponses } from "features/requests/types/checklists";
import { ChecklistModalContent } from "./checklist-modal-content";
import { useTranslation } from "react-i18next";

interface IProps {
  appointmentId: number;
}

export const AppointmentChecklists = ({ appointmentId }: IProps) => {
  const { t } = useTranslation();
  const tBase = "features.requests";
  const tr = (key: string) => t(`${tBase}.${key}`);

  const { setModal } = useModalContext();
  const { data, isError, isLoading } = useAppointmentChecklists(appointmentId);

  const rows: IChecklistWithResponses[] = data ?? [];
  const totalCount = rows.length;
  const completeCount = rows.filter((row) => row.is_done).length;
  const checklistComplete = completeCount === totalCount;

  const handleOpenChecklists = () => {
    if (!rows.length) return;
    setModal({
      component: <ChecklistModalContent checklist={rows} />,
      label: tr("Checklists"),
    });
  };

  if (isLoading)
    return (
      <>
        <h2>{tr("Checklists")}</h2>
        <div>
          <Spinner />
        </div>
        <div className="mt-2" />
        <hr />
      </>
    );

  if (isError)
    return (
      <>
        <h2>{tr("Checklists")}</h2>
        <div>{tr("Something went wrong.")}</div>
        <div className="mt-2" />
        <hr />
      </>
    );

  return (
    <>
      <h2>{tr("Checklists")}</h2>

      {rows.length > 0 ? (
        <div className="flex flex-row flex-wrap mt-2">
          <div className="mr-2 mb-2">
            <OutlineButton type="button" onClick={handleOpenChecklists}>
              {tr("View checklists")}
              <div className={` ${checklistComplete ? "text-green-600" : "text-gray-500"}`}>
                ({completeCount} / {totalCount})
              </div>
            </OutlineButton>
          </div>
        </div>
      ) : null}
      {rows.length === 0 ? (
        <div className="mt-2">{tr("No Checklists Entered")}</div>
      ) : null}
      <div className="mt-2" />
      <hr />
    </>
  );
};
